import taskIcon from "../otherNavItems/iconCanot/task.png";
import messangerIcon from "../otherNavItems/iconCanot/messanger.png";
import settingsIcon from "../otherNavItems/iconCanot/settings.png";
import employsIcon from "../otherNavItems/iconCanot/employs.png";
import apiIcon from "../otherNavItems/iconCanot/api.png";
import ozonIcon from "../otherNavItems/iconCanot/ozon.png";
import wbIcon from "../otherNavItems/iconCanot/wb.png";
import videoChatIcon from "../otherNavItems/iconCanot/video-chat.png";
import paymentIcon from "../otherNavItems/iconCanot/payment.png";

const ICONS = [
  taskIcon,
  messangerIcon,
  settingsIcon,
  employsIcon,
  apiIcon,
  ozonIcon,
  wbIcon,
  videoChatIcon,
  paymentIcon,
];

let isPreloaded = false;

export function preloadOtherMenuIcons() {
  if (isPreloaded) return;
  isPreloaded = true;

  ICONS.forEach((src) => {
    const img = new Image();
    img.decoding = "async";
    img.src = src;
  });
}